/**
 * The app-wide React Query client.
 *
 * Lives in its own module (instead of App.js) so that low-level services
 * such as services/api.js can reach it - e.g. to clear the cache on logout -
 * without importing App.js, which would create a circular import through the
 * router and every page. App.js re-exports it, so `import { queryClient } from
 * "../App"` keeps working.
 */
import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { logClientError } from "./systemLogs";

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      logClientError("react-query.query", error, {
        queryKey: query?.queryKey || [],
      });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      logClientError("react-query.mutation", error, {
        mutationKey: mutation?.options?.mutationKey || [],
      });
    },
  }),
});

export default queryClient;
